import axios from 'axios';
import Config from '../utils/config';
import { store } from '../store';
import { notificationFail } from 'store/slices/notificationSlice';
const baseURL = Config.API_URL;

const handleLogout = async () => {
  localStorage.removeItem('user_data');
  localStorage.removeItem('sortActions');
  localStorage.removeItem('visibleColumns');
  localStorage.removeItem('selectedDates');
  localStorage.removeItem('sortActions_cogs');
  localStorage.removeItem('selectedTab');
  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    } catch (error) {
      console.error('Error clearing cache:', error);
    }
  }
  window.location.replace('/login');
};

const apiClient = (isFormData = false) => {
  let headers = {
    'Access-Control-Allow-Origin': '*'
    // 'Access-Control-Request-Headers': 'origin, Content-Type, x-requested-with, accept'
  };

  let userdata = window.localStorage.getItem('user_data');

  if (userdata) {
    userdata = JSON.parse(userdata);
    headers = {
      ...headers,
      Authorization: `Berear ${userdata.accessToken}`,
      'Access-Control-Allow-Headers': 'origin,x-requested-with,content-type,accept'
    };
  }

  if (isFormData) {
    Object.assign(headers, { 'content-type': 'multipart/form-data' });
  }
  const instance = axios.create({
    baseURL,
    withCredentials: false,
    headers
  });

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalRequest = error.config;
      if (error?.response?.status === 401) {
        store.dispatch(notificationFail('Your session has expired. Please log in again to continue accessing the platform.'));
        handleLogout();
        return instance(originalRequest);
      }
      return Promise.reject(error);
    }
  );

  return instance;
};
export default apiClient;
